import { useSelector } from 'react-redux';
import styled from 'styled-components';
import i18n from 'src/utils/translate';
import CommunityHeaderContent from './communityHeaderContent';
import CommunityHeaderNavBar from './communityHeaderNavBar';
import { getCommunityBannerUrl } from 'src/utils/linkUtils';
import ImageUpload from 'src/components/imageUpload';
import { saveAndCropBannerImage } from 'src/api/community';
import { State } from 'src/types';


export default function CommunityHeader({ currentPage = '' }: { currentPage?: string }) {
  const currentCommunity = useSelector(({context}: State) => context.currentCommunity);
  const currentUser = useSelector(({context}: State) => context.currentUser);

  const imageUrl = getCommunityBannerUrl(currentCommunity?.bannerImageHash);
  const imageUrlMobile = getCommunityBannerUrl(currentCommunity?.bannerImageHash, true);
  const isHUStaff = !!currentUser && !!currentUser.roles && !!currentUser.roles.includes('HealthUnlocked');

  return (
    <div className="community-header">
      {isHUStaff
        ?
          <ImageUpload
            boundary={{ width: 2500, height: 500 }}
            buttonText={i18n.t('Add banner')}
            className="community-header__cover"
            communitySlug={currentCommunity?.slug}
            currentImageUrl={imageUrl}
            fitWidth={true}
            savePreviewLocally={true}
            onSave={saveAndCropBannerImage}
          />
        :
          <Banner className="community-header__cover" imageUrl={imageUrl}
            imageUrlMobile={imageUrlMobile} />
      }
      <CommunityHeaderContent
        community={currentCommunity}
        currentPage={currentPage}
        currentUser={currentUser}
      />
      <CommunityHeaderNavBar
        community={currentCommunity}
        currentPage={currentPage}
        currentUser={currentUser}
      />
    </div>
  );
}

const Banner = styled.div<{imageUrl: string, imageUrlMobile: string}>`
  background-image: url(${({imageUrlMobile}) => imageUrlMobile});
  @media (${({theme}) => theme.overScreenMedium}) {
    background-image: url(${({imageUrl}) => imageUrl});
  }
`;
